import { render } from "./AuthorityEdit.vue?vue&type=template&id=58e940a2"
import script from "./AuthorityEdit.vue?vue&type=script&lang=js"
export * from "./AuthorityEdit.vue?vue&type=script&lang=js"

import exportComponent from "D:\\LuisFolder\\project\\evcharge-ev-server-rocketmq\\evcharge-vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__